module.exports = __webpack_public_path__ + "img/P14_Mitsui_2014-10-1-7.b9839cd4.jpg";